import React from 'react';
import { ChartComponent, SeriesCollectionDirective, SeriesDirective, Inject, LineSeries, DateTime, Legend, Tooltip, DataLabel } from '@syncfusion/ej2-react-charts';

import { lineCustomSeriesEDAratingTrend, LinePrimaryYAxisRating, LinePrimaryYAxisSentiment, lineChartDataSentimentTrend, 
          lineCustomSeriesSentimentTrend, lineCustomSeriesAItotalTrend, 
          lineChartDataAItotalTrend, lineCustomSeriesIntentTrend, lineCustomSeriesIntentDetailTrendSpam,
          lineChartDataIntentTrend, lineChartDataIntentDetailTrend, lineCustomSeriesIntentDetailTrend} from '../../data/dummy';
import { useStateContext } from '../../contexts/ContextProvider';

const LineChartEDAratingTrend = ({ AItype, colors, fontsize, id, intent, chartTpye}) => {
  const { currentMode } = useStateContext();

  let dataset = lineCustomSeriesEDAratingTrend;
  let LinePrimaryYAxis = LinePrimaryYAxisRating;

  if (AItype === 'classifiedSentiment') {
    dataset = lineCustomSeriesSentimentTrend;
    LinePrimaryYAxis = LinePrimaryYAxisSentiment;
  }
  
  else if (AItype === 'classifiedIntent' && chartTpye == 'intent-overview') {
    dataset = lineCustomSeriesIntentTrend;
    const maxValue = Math.max(...lineChartDataIntentTrend.flat().map(data => data.y))
    LinePrimaryYAxis = {
      labelFormat: '{value}',
      rangePadding: 'None',
      minimum: 0,
      maximum: maxValue + 20,
      interval: Math.ceil((maxValue + 20) / 3 / 10) * 10,
      lineStyle: { width: 0 },
      majorTickLines: { width: 0 },
      minorTickLines: { width: 0 },
      majorGridLines: { width: 0 }
    };;
  }

  else if (AItype === 'classifiedIntent' && chartTpye == 'intent-detail') {
    dataset = lineCustomSeriesIntentDetailTrend(intent);
    const flatData = lineChartDataIntentDetailTrend[intent]?.flat() || [];
    const maxValue = Math.max(...flatData.map((item) => item.y), 0);
    LinePrimaryYAxis = {
      labelFormat: '{value}',
      rangePadding: 'None',
      minimum: 0,
      maximum: maxValue + 20,
      interval: Math.ceil((maxValue + 20) / 3 / 10) * 10,
      lineStyle: { width: 0 },
      majorTickLines: { width: 0 },
      minorTickLines: { width: 0 },
      majorGridLines: { width: 0 }
    };;
  }

  else if (AItype === 'classifiedIntent' && chartTpye == 'intent-detail-spam') {
    dataset = lineCustomSeriesIntentDetailTrendSpam(intent);
    const flatData = lineChartDataIntentDetailTrend[intent]?.flat() || [];
    const maxValue = Math.max(...flatData.map((item) => item.y), 0);
    LinePrimaryYAxis = {
      labelFormat: '{value}',
      rangePadding: 'None',
      minimum: 0,
      maximum: maxValue + 20,
      interval: Math.ceil((maxValue + 20) / 3 / 10) * 10,
      lineStyle: { width: 0 },
      majorTickLines: { width: 0 },
      minorTickLines: { width: 0 },
      majorGridLines: { width: 0 }
    };;
  }
  
  else if (AItype === 'classifiedTotal') {
    if (!intent || !lineChartDataAItotalTrend[intent]) {
      console.error("Invalid or missing intent:", intent);
      return <p>Data is not available for the selected intent.</p>;
    }

    dataset = lineCustomSeriesAItotalTrend(intent);
    const flatData = lineChartDataAItotalTrend[intent]?.flat() || [];
    const maxValue = Math.max(...flatData.map((item) => item.y), 0);

    LinePrimaryYAxis = {
      labelFormat: '{value}',
      rangePadding: 'None',
      minimum: 0,
      maximum: maxValue + 20,
      interval: Math.ceil((maxValue + 20) / 3 / 10) * 10,
      lineStyle: { width: 0 },
      majorTickLines: { width: 0 },
      minorTickLines: { width: 0 },
      majorGridLines: { width: 0 },
    };
  }


  // X축 설정
  const LinePrimaryXAxis = {
    valueType: 'DateTime',
    intervalType: 'Months',
    labelFormat: "yy년 M월", // 사용자 정의 형식
    edgeLabelPlacement: 'Shift', // 오른쪽 레이블이 잘리지 않도록 설정
    majorGridLines: { width: 0 },
  };

  // 데이터 레이블 렌더링
  const onTextRender = (args) => {
    const lastPointIndex = args.series.points.length - 1;
    if (args.point.index === lastPointIndex) {
      args.text = args.text; // 텍스트 유지
      args.location.x -= 20; // X축 위치 왼쪽으로 이동
    }
  };

  // 색상 배열 정의 (빨간색, 검정색, 파란색)
  const lineColors = colors;

  // ['red', 'black', 'blue'];
  return (
    <ChartComponent
      id={id}
      primaryXAxis={LinePrimaryXAxis}
      primaryYAxis={LinePrimaryYAxis}
      chartArea={{ border: { width: 0 } }}
      tooltip={{ enable: true }}
      background={currentMode === 'Dark' ? '#33373E' : '#fff'}
      legendSettings={{ background: 'white' }}
      // margin={{ right: 50 }} // 오른쪽 마진 추가
      textRender={onTextRender} // 데이터 레이블 텍스트 위치 조정
    >
      <Inject services={[LineSeries, DateTime, Legend, Tooltip, DataLabel]} />
      <SeriesCollectionDirective>
        {dataset.map((item, index) => (
          <SeriesDirective
            key={index}
            {...item}
            fill={lineColors[index]}
            marker={{
              visible: true,
              dataLabel: {
                visible: true,
                position: 'Outer', // 기본적으로 외부에 표시
                font: { size: fontsize, color: currentMode === 'Dark' ? '#fff' : '#000' },
              },
            }}
          />
        ))}
      </SeriesCollectionDirective>
    </ChartComponent>
  );
};

export default LineChartEDAratingTrend;
